import type { DeleteClauseVariationsProps, BlockState } from '../types';

export const deleteClauseVariationsReducer = (
    state: BlockState,
    { clauseId, blockId }: DeleteClauseVariationsProps
) => ({
    ...state,
    blocks: state.blocks.map(block =>
        block.id === blockId
            ? {
                  ...block,
                  groups: [
                      {
                          fields: block.groups[0].fields.map(field => {
                              if (field.id === clauseId) {
                                  return {
                                      ...field,
                                      content: field.content.map(item =>
                                          item.isDefault ? { ...item, show: true } : { ...item, show: false }
                                      ),
                                      variationsField: undefined
                                  };
                              }

                              return field;
                          })
                      }
                  ]
              }
            : block
    )
});
